import { gql } from "@apollo/client";

/** Full-width hero image (desktop). */
export const HERO_INTRO_IMAGE = gql`
  fragment HeroIntroImage on FileField {
    id
    responsiveImage(
      imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "1560", h: "500", q: "75" }
    ) {
      alt
      height
      src
      title
      width
    }
  }
`;

/** Smaller crop of the same asset for mobile LCP (same focal point, ~525px wide). */
export const HERO_INTRO_IMAGE_MOBILE = gql`
  fragment HeroIntroImageMobile on FileField {
    id
    responsiveImage(
      imgixParams: { auto: format, fit: crop, crop: focalpoint, w: "525", h: "375", q: "75" }
    ) {
      alt
      height
      src
      title
      width
    }
  }
`;
